<div class="card-content">
  <div class="coin-display__card">
    <div class="card-top">
      <div class="display-card__title">
        <h4 class="coin-detail__title">Coin Details </h4>
      </div>
      <p *ngIf="page !='assess'" class="text-white">({{coin?.custom_id}})</p>
      <div class=" d-flex align-items-center">
        <a *ngIf="auth.userAuthData && isPersonal()" class="chat-icon" (click)="identificationComment(coin?.id)">
          <img src="assets/images/icons/chat-icon.png" alt="chat-icon">
          <span class="items">{{ totalComments }}</span>
        </a>
        <a [routerLink]="['/user/dashboard/coin-detail', coin?.id]" *ngIf="isPersonal()">
          <img src="assets/images/icons/edit-icon.png" alt="edit-icon">
        </a>
        <a *ngIf="allowReport && auth.userAuthData && !isPersonal()" (click)="isBlockForm = true">
          <img src="assets/images/icons/flagicon.svg" alt="flag-icon">
        </a>
      </div>
    </div>

    <div (click)="navigate()">
      <div class="coin-details__meta" *ngIf="coin">
        <div class="row">
          <ng-container *ngFor="let detail of coinDetails">
            <div class="col-md-6 col-6">
              <ul class="coin-details__meta-group">
                <li class="coin-details__meta-label">{{ detail.label }}</li>
                <li class="coin-details__meta-des">{{ detail.value || 'N/A' }}</li>
              </ul>
            </div>
          </ng-container>
        </div>
      </div>



      <div class="img-box">
        <div class="left-coin__img">
          <img [src]="getTransformedImageUrl(coin?.front_image_url) || 'assets/images/gallery/picupload.png'" 
               class="img-fluid coin-img" 
               alt="coin-imgone">
        </div>
        <div class="right-coin__img">
          <img [src]="getTransformedImageUrl(coin?.back_image_url) || 'assets/images/gallery/picupload.png'" 
               class="img-fluid coin-img" 
               alt="coin-imgone">
        </div>
      </div>



      <div *ngIf="!isPersonal()">
        <div class="display-card__button" *ngIf="isActionButton && !isAssessments() && page == 'master'">
          <button class="primary-btn btn" >Coin Detail</button>
        </div>
  
        <div class="display-card__button" *ngIf="isActionButton && page == 'identify'">
          <button class="primary-btn btn" *ngIf="coin?.status == 'identify'">Identify Coin Now</button>
        </div>
  
        <div class="display-card__button" *ngIf="isActionButton && page == 'assess'">
          <button class="primary-btn btn" *ngIf="coin?.status == 'assess'">Assess Coin Now</button>
        </div>
      </div>

      <div *ngIf="isPersonal()">
        <div class="display-card__button" >
          <button class="primary-btn btn" >Coin Detail</button>
        </div>
      </div>
     

      <div class="display-card__details" *ngIf="isAssessments() && isStats">
        <div class="col-12">

          <h3>Assessment Details</h3>

        </div>
        <div class="assesment-details">
          <div class="assesment-details__text">
            <span class="elipse-one"></span>
            <div>
              <p class="elipse-title">Mean</p>
              <p class="elipse-value">{{utility.formatDecimal(coin?.mean)}}</p>
            </div>
          </div>
          <div class="assesment-details__text">
            <span class="elipse-two"></span>
            <div>
              <p class="elipse-title">Median</p>
              <p class="elipse-value">{{utility.formatDecimal(coin?.median)}}</p>
            </div>
          </div>
          <div class="assesment-details__text">
            <span class="elipse-three"></span>
            <div>
              <p class="elipse-title">Mode</p>
              <p class="elipse-value">{{utility.formatDecimal(coin?.mode)}}</p>
            </div>
          </div>

        </div>
        <div class="total-assesment">
          <span class="total-value_assesment">{{totalAssessments}}</span>
          <span class="total-value_title">Total Assessments</span>
        </div>
      </div>

      <!-- <div class="display-card__button" *ngIf="!auth.userAuthData && !isAssessments()">
        <button class="primary-btn btn">Coin Detail</button>
      </div> -->




      <div class="display-card__button" *ngIf="isSimilarCoin">
        <button type="button" class="primary-btn btn">Coin Detail</button>
      </div>
    </div>

    <div class="report-textarea" *ngIf="isBlockForm">
      <form #reportForm="ngForm" (ngSubmit)="submitForm(reportForm)">
        <textarea class="form-control" [(ngModel)]="comment" name="comment" placeholder="Enter your message" rows="3"
          required #commentInput="ngModel"></textarea>
        <button id="custom-button" type="submit" class="btn" [disabled]="!reportForm.valid">Report</button>
      </form>
    </div>
  </div>
</div>